module.exports = __webpack_public_path__ + "img/footIconThree.53d038ec.png";